export default __webpack_public_path__ + "static/new-placeholder-c842a87ebbefe55755a6bd44c6b9a26b.jpg";